import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ZipcodeService {
  constructor(private http: HttpClient) { }

  search(zipcode: string) {
    console.log(zipcode)
    zipcode = zipcode.replace(/\D/g, '');

    if (zipcode !== '') {
      const validateZipcode = /^[0-9]{8}$/;

      if (validateZipcode.test(zipcode)) {
        return this.http.get(`${environment.viaCep}/${zipcode}/json`);
      }
    }

    return of({});
  }
}
